import React, { JSX, useState } from 'react';

import { track } from '~/src/dash/analytics/analytics';
import { SimpleTabs } from '~/src/dash/components/tabs/SimpleTabs';
import { SimpleTabSections } from '~/src/dash/components/tabs/SimpleTabSections';
import { Panel, Panels, spacing } from '~/src/dash/publicaUI';
import { useBaseConfig, useBaseStore } from '~/src/dash/views/base/contexts';
import { InventoryRulesListContext } from '~/src/dash/views/inventory-rules-v2/Rules/contexts';
import { RulesList } from '~/src/dash/views/inventory-rules-v2/Rules/InventoryRulesList';
import { TopBar } from '~/src/dash/views/topbar/TopBar';
import { Settings } from '~/src/dash/views/inventory-rules-v2/Settings';

export const InventoryRulesList = (): JSX.Element => {
  const { user, isSuperUser } = useBaseStore();
  const { InventoryRules } = useBaseConfig();
  const cfg = InventoryRules.Rules.Main;

  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

  const handleChangeTab = (_event: React.SyntheticEvent, index: number): void => {
    const tabKey = cfg.tabs.find((tab) => tab.value === index)?.key;
    track(`Inventory Rules List - View ${tabKey} Tab`, { isSuperUser }, user.user);
    setActiveTabIndex(index);
  };

  return (
    <InventoryRulesListContext.Provider value={{ cfg }}>
      <Panels max vertical relative minWidthMain>
        <Panel largeHorizontalPadding smallVerticalPadding>
          <TopBar title='Inventory Rules' enableUINotices tKey={'InventoryRules'} />
        </Panel>
        <Panel>
          <SimpleTabs
            activeTabIndex={activeTabIndex}
            ariaLabel='Inventory Rules'
            handleChangeTab={handleChangeTab}
            tabs={cfg.tabs}
          />
        </Panel>
        <Panel scroll paddingTop={spacing.small}>
          <SimpleTabSections
            activeTabIndex={activeTabIndex}
            sections={[<RulesList />, <Settings />]}
          />
        </Panel>
      </Panels>
    </InventoryRulesListContext.Provider>
  );
};
